import { cn } from "@maker/utils/cn";
import { cloneElement } from "react";
import { buttonVariants } from "./button";

type MenuProps = React.ComponentProps<"nav">;

type MenuItemProps = React.ComponentProps<"a"> & {
	render?: React.ReactElement<{ className?: string }>;
	format?: "text" | "icon";
};

const Menu = ({ className, ...props }: MenuProps) => {
	return (
		<nav
			className={cn(
				"flex flex-row border-neutral-100 border-b bg-neutral-50",
				className,
			)}
			{...props}
		/>
	);
};

const MenuItem = ({
	className,
	render,
	format = "text",
	...props
}: MenuItemProps) => {
	const mergedClassName = cn(
		buttonVariants({
			className:
				"rounded-none border-transparent border-b-2 px-4 py-3 text-neutral-500 text-xs hover:text-neutral-900",
		}),
		{
			"[&_svg]:h-2.75 [&_svg]:w-2.75": format === "text",
			"[&_svg]:h-4 [&_svg]:w-4": format === "icon",
		},
		"aria-[current=page]:border-b-neutral-900 aria-[current=page]:text-neutral-900 data-[active=true]:border-b-2 data-[active=true]:border-b-neutral-900 data-[active=true]:text-neutral-900",
		className,
	);
	const clonedRender = render
		? cloneElement(render, { className: mergedClassName })
		: null;

	return clonedRender ? (
		clonedRender
	) : (
		<a className={mergedClassName} {...props} />
	);
};

export { Menu, MenuItem, type MenuProps, type MenuItemProps };
